<template>
	<div v-if="jewellery.SKU == proSlug" class="page-wrapper jewellerycard ">
        <div class="page-grid-wrapper jewellery-card-wrapper" v-if="!authUser && jewellery.MembersAreaOnly === 0" :key="jewellery.SKU">
            <div class="page-grid-full-screen"> 
                <article class="grid-container columns-two">
                    <section class="section1">
                        <div class="jewellery-card-gallery">
                             <div v-if="isGalleryLoading" class="gallery-spinner">
                                <span class="loader"></span>
                                <p>Loading {{ jewellery.Name }} gallery...</p>
                            </div>
                            <div v-else class="jewellery-gallery-item">
                                <div id="card-slider">
                                    <!-- FIRST IMAGE IN THE GALLERY --><!-- ALL GALLERY IMAGES --><!-- Add cssClass: mz-show-arrows; for arrow in gallery -->
                                    <a 
                                        :href="`/jewelries/gallery/NJ-${jewellery.SKU}/gallery-large-image/${images[0].name}`" 
                                        class="MagicZoom" 
                                        id="jewelleryimage" 
                                        data-options="cssClass: mz-show-arrows no-expand-thumbnails; zoomMode: off; hint: off; lazyZoom: true;"
                                    >
                                        <img :src="`/jewelries/gallery/NJ-${jewellery.SKU}/gallery-small-image/${images[0].name}`" />
                                    </a>
                                
                                    <div class="MagicScroll" data-options="arrows:inside; items:3; step: 1;" style="height: 100%; padding-top: 25px;" >
                                        <a v-for="image in images" 
                                        :key="image.SKU" 
                                        data-zoom-id="jewelleryimage"
                                        :href="`/jewelries/gallery/NJ-${jewellery.SKU}/gallery-large-image/${image.name}`"
                                        :data-image="`/jewelries/gallery/NJ-${jewellery.SKU}/gallery-small-image/${image.name}`"
                                      >
                                          <img :src="`/jewelries/gallery/NJ-${jewellery.SKU}/thumb-image/${image.name}`" />
                                        </a>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </section>

                    <section class="section2">
                        <div class="jewellery-card-details" ref="jewelleryCardDetails">
                            <h2>{{ jewellery.Name }}</h2>
                            <template  v-if='jewellery.SKU'>
                              <div style="margin: -35px 0px 35px 0; font-size: 0.8rem;">Stock No: NW-{{ jewellery.SKU }}</div>
                            </template>
                            <article class="grid-container columns-two columns-two-mobile bordered no-gap-column"> 
                                <section>
                                    <span v-if="jewellery.StatusName === 'Sold'">Sold</span>
                                    <span v-else class="status">In Stock<br>
                                      <!-- <small v-if='jewellery.JewelleryLocation' style="text-transform: initial;">In our <router-link :to="{ path: '/locations', hash: '#' + jewellery.JewelleryLocation }" style="color: #ae9248; text-transform: capitalize; ">{{jewellery.JewelleryLocation}}</router-link> boutique</small> -->
                                        <small v-if="jewellery.JewelleryLocation" style="text-transform: initial;">
                                          In our
                                          <template v-if="jewellery.JewelleryLocation === 'UAE'">
                                            <span>
                                              {{ jewellery.JewelleryLocation }}
                                            </span>
                                            office
                                          </template>
                                          <template v-else>
                                            <router-link
                                              :to="{ path: '/locations', hash: '#' + jewellery.JewelleryLocation }"
                                              style="color: #ae9248;"
                                            >
                                              {{ jewellery.JewelleryLocation }}
                                            </router-link>
                                            boutique
                                          </template>
                                          
                                        </small>
                                    </span>
                                </section>
                                <section>
                                    <span v-if="jewellery.isPOA" class="status">POA</span>
                                  <span v-else class="price">
                                    <span class="currency">{{ jewellery.currencySymbol }}</span>
                                      {{ jewellery.displayPrice }}
                                    <br>
                                    <span class="exc-taxes" v-if="jewellery.showExcTaxes"><small>&nbsp;exc.&ensp;taxes</small></span>
                                  </span>
                                   
                                </section>   
                            </article>
                        <!-- Contact section -->    
                          <article class="grid-container columns-two columns-two-mobile" style="width: 100%; grid-template-columns: 2fr 1fr 2fr; margin: 35px 0 -15px 0;">      
                                <section>
                                    <button class="center clean-link" type="submit" style="text-align: right !important;">

                                    <a v-if="contactDetails.whatsappLink"
                                      :href="contactDetails.whatsappLink"
                                      target="_blank" style="color: #ae9248 !important;"><img style="filter: invert(0%);" src="/images/icons/whatsapp-gold.svg">
                                      WhatsApp us
                                    </a>

                                    </button>
                                </section>
                                <section>
                                    <button class="center clean-link" type="submit">
                                        <a v-if="contactDetails.phoneNumber"
                                          :href="'tel:' + contactDetails.phoneNumber" style="color: #ae9248 !important;"><img style="filter: invert(0%);" src="/images/icons/phone-gold.svg"></img>
                                          Call us
                                        </a>
                                    </button>
                                </section>
                                <section>
                                  <span @click="toggleArticles" class="center clean-link" style="text-align: left !important; top: 4px !important; position: relative;">
                                    <a class="show-more" v-if="showArticles" >Hide Form</a>
                                    <a class="show-more" v-else><img style="filter: invert(0%); height: 18px; vertical-align: text-top; margin-right: 10px;" src="/images/icons/write-to-us-gold.svg">Write to Us</a>
                                  </span>
                                </section>
                            </article>
                            <!-- <article class="grid-container columns-two columns-two-mobile">      
                                <section>
                                    <button class="center clean-link" type="submit">
                                    <a v-if="contactDetails.whatsappLink"
                                      :href="contactDetails.whatsappLink"
                                      target="_blank"><img src="/images/icons/whatsapp-grey.svg">
                                      WhatsApp us
                                    </a>
                                    </button>
                                </section>
                                <section>
                                    <button class="center clean-link" type="submit">
                                      <a v-if="contactDetails.phoneNumber"
                                          :href="'tel:' + contactDetails.phoneNumber"><img class="" src="/images/icons/phone-grey.svg"></img>
                                          Call us
                                        </a>
                                    </button>
                                </section>
                            </article> -->
                            <!-- <article class="toggle-arrow center">
                                <span @click="toggleArticles" >
                                    <a class="show-more" v-if="showArticles" >Hide Form</a>
                                    <a class="show-more" v-else>Write to Us</a>
                                </span>
                            </article> -->
                            <article style="margin-top: 0;" v-show="showArticles">
                                <section>
                                            <!-- <pre>Send us a message</pre> -->
                                    <EnquiryForm :Model="jewellery.Model" :SKU="jewellery.SKU" formOrigin="Detail Page Enquiry " ></EnquiryForm>
                                </section>
                            </article>

                        <!-- End Contact section --> 

                            <p class="show-more-container vhtml" :class="{ 'expanded': expanded }" ref="textElement" v-html="jewellery.Description"></p>
                            <a class="show-more" v-if="!expanded && isLongDescription" @click="expandText">Read more</a>
                            <a class="show-more" v-if="expanded" @click="contractText">Show less</a>

                            <!-- <article class="grid-container columns-one-centered bordered-bottom no-gap-column"> 
                                <section class="section1">
                                    <span class="stock-number" v-if='jewellery.SKU'>Stock No:&emsp;NJ-{{ jewellery.SKU }}</span>
                                </section>
                                
                            </article> -->

                            <!-- <article style="margin-top: 40px;">
                                <h2 style="margin: 0;">Enquire</h2> 
                               
                            </article>
                            <article class="grid-container columns-two columns-two-mobile">
                                <section>
                                    <button class="right" type="submit">
                                        <a :href="'https://api.whatsapp.com/send?phone=' + londonboutique.WhatsAppNumber">WhatsApp us<img class="center" src="/images/icons/ArrowRight.svg"></a>
                                    </button>
                                </section>
                                <section>
                                    <button class="right" type="submit">
                                        <a class="phone_number" :href="'tel:' + londonboutique.PhoneNumber">Call us<img class="center" src="/images/icons/ArrowRight.svg"></a>
                                    </button>
                                </section>
                            </article>
                            <article class="toggle-arrow">
                                <span @click="toggleArticles" >
                                    <a class="show-more" v-if="showArticles" >Show less</a>
                                    <a class="show-more" v-else>Show more</a>
                                </span>
                            </article>
                            <article style="margin-top: 0;" v-show="showArticles">
                                <section>  
                                    <pre>Send us a message</pre>      
                                    <EnquiryForm :Model="jewellery.Model" :SKU="jewellery.SKU" formOrigin="'Detail Page Enquiry about' +  jewellery.SKU" ></EnquiryForm>
                                </section>
                            </article> -->
              
                        </div>
                    </section>
                </article>
            </div>
        </div>
        <div class="page-grid-wrapper" v-else-if="!authUser && jewellery.MembersAreaOnly === 1" >  

            <div class="page-grid jewellery-card-wrapper" :key="jewellery.SKU">
                <div v-if="!authUser && jewellery.MembersAreaOnly === 1" :key="jewellery.SKU">
                    <div>
                        <h2>Content of this page is available to members only.</h2><br />
                        <router-link to="register"><span class="no-mobile">Register</span></router-link>
                    </div>
                </div>
			    <article class="grid-container columns-two">
                    <section class="section1">

                        <div class="jewellery-card-gallery">
                            <div class="jewellery-gallery-item">
                            <div id="card-slider">
                                    <!-- FIRST IMAGE IN THE GALLERY --><!-- ALL GALLERY IMAGES -->
                                <a :href="'/jewelries/gallery/NJ-' + jewellery.SKU + '/gallery-large-image/' + images[0].name" class="MagicZoom" id="jewelleryimage" data-options="cssClass: mz-show-arrows no-expand-thumbnails; zoomMode: off; hint: off;"><img :src="'/jewelries/gallery/NJ-' + jewellery.SKU + '/gallery-small-image/' + images[0].name"></a>
                                <a v-for="image in images" data-zoom-id="jewelleryimage" :href="'/jewelries/gallery/NJ-' + jewellery.SKU + '/gallery-large-image/' + image.name" :data-image="'/jewelries/gallery/NJ-' + jewellery.SKU + '/gallery-small-image/' + image.name"><img style=" width: 70px;" :src="'/jewelries/gallery/NJ-' + jewellery.SKU + '/thumb-image/' + image.name"></a>
                                
                                </div>
                            </div> 
                        </div>
                                    
                    </section>
                    <section class="section2">
                        <div class="jewellery-card-details">
                            <h2>{{ jewellery.Name }}</h2>
                            <article>
                                <section class="vhtml" v-html="jewellery.Description"></section>
                                <section >
                                    <div class="table-wrapper product-features left">
                                        <div class="div-table">
                                            <div class="div-row"  v-if='jewellery.SKU'>
                                            <div  class="div-cell">Stock No:</div><div  class="div-cell">NJ-{{ jewellery.SKU }}</div>
                                            </div>
                                            <div class="div-row"  v-if='jewellery.Box'>
                                            <div  class="div-cell">Box </div><div  class="div-cell">{{ jewellery.Box }}</div>
                                            </div><div class="div-row"  v-if='jewellery.Papers == "Yes"'>
                                            <div  class="div-cell">Papers</div><div  class="div-cell">{{ jewellery.Papers }}</div>
                                             </div>
                                             <div class="div-row"  v-if='jewellery.Warranty == "Yes"'>
                                            <div  class="div-cell">Certificate of Authenticity</div><div  class="div-cell">{{ jewellery.Warranty }}</div>
                                            </div>
                                            <div class="div-row"  v-if='jewellery.PreOwnedWarranty == "Yes"'>
                                                <div  class="div-cell">Pre-Owned Warranty</div><div  class="div-cell">{{ jewellery.PreOwnedWarranty }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-wrapper product-features right">
                                        <div class="div-table">
                                        <div class="div-row" v-if='jewellery.WaterResistance'>
                                            <div  class="div-cell">Water Resistant:</div> <div  class="div-cell">{{ jewellery.WaterResistance }}</div>
                                            </div><div class="div-row"  v-if='jewellery.Strap'>
                                            <div  class="div-cell">Strap:</div> <div  class="div-cell">{{ jewellery.Strap }}</div>
                                            </div><div class="div-row"  v-if='jewellery.Buckle'>
                                            <div  class="div-cell">Buckle:</div><div  class="div-cell">{{ jewellery.Buckle }}</div>
                                            </div><div class="div-row"  v-if='jewellery.Year'>
                                            <div  class="div-cell">Year: </div><div  class="div-cell">{{ jewellery.Year }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <h2 class="status" style="margin-top: 2.5vh;" v-if="jewellery.StatusName === 'Sold'">POA</h2>
                                    <h2 class="price" style="margin-top: 2.5vh;" v-else-if="Number(jewellery.Price) > Number(siteSettings.poa_price_tag)">POA</h2>
                                    <h2 class="price" style="margin-top: 2.5vh;" v-else><span class="currancy" style="">£</span>
                                    <span  class="price">{{ jewellery.Price | formatNumber }}</span></h2>
                                             
                                </section>
                                <section>                   
                                    <a 
                                      :href="'https://api.whatsapp.com/send?phone=' 
                                        + londonboutique.WhatsAppNumber 
                                        + '&text=' 
                                        + encodeURIComponent('Hello!\nI am enquiring about ' + jewellery.Name + ' - ' + jewellery.SKU)">
                                        <img src="/images/icons/whatsapp-grey.svg"> 
                                        <span>WhatsApp us</span>
                                    </a>                        
                                    <a class="phone_number" :href="'tel:' + londonboutique.PhoneNumber">
                                        <img src="/images/icons/phone-grey.svg">
                                        <span>Call us</span>
                                    </a>
                                </section>
                                <section>
                                    <span class="large">Enquire about this jewellery</span>
                                                    
                                    <h2></h2>
                                    <EnquiryForm :Model="jewellery.Model" :SKU="jewellery.SKU" formOrigin="Detail Page Enquiry " ></EnquiryForm>

                                </section>    
                                
                                <br><br><br><br>
                            </article>
                        </div>
                    </section>
                </article>
            </div>        
        </div>
        <JewelleryVariants :manufacturername="jewellery.ManufacturerName" :sku="jewellery.SKU"></JewelleryVariants>
        <div class="space-helper"></div>
    </div>
</template>
<style>

</style>










<script>

import EnquiryForm from '../components/EnquiryForm.vue';
import JewelleryVariants from '../components/JewelleryVariants.vue';
import { mapGetters } from "vuex";
// import store from "../store/index";
import axios from 'axios';

export default {
  name: 'jewellerycard',
  
  components: {
    EnquiryForm,
    JewelleryVariants,
  },
  props: ["manufacturername", "model", "sku", "movement", "material", "gender"],
  
  data() {
    return {
      showArticles: false,
      jewellery: [],
      images: [],
      proSlug: null, // Initialize proSlug as null
      londonboutique: [],
      expanded: false,
      isLongDescription: false,
      axiosCancelToken: null,
      isGalleryLoading: true, // spinner state
    };
  },
  
  created() {
    // Check the route parameter on component creation
    if (this.$route.params.jewellerySKU) {
      this.proSlug = this.$route.params.jewellerySKU; // Set proSlug from route
      this.loadJewellery(this.proSlug); // Fetch jewellery data
    }
  },
  
  watch: {
    '$route.params.jewellerySKU' (newSlug) {
      this.proSlug = newSlug; // Update proSlug when the route changes
      this.loadJewellery(newSlug); // Fetch new jewellery data
    },
  },

  mounted() {
    this.getLondonBoutique(); // Fetch London boutique data
    this.checkDescriptionLength(); // Check if text is long on component mount
    window.addEventListener('resize', this.handleResize); // Listen for window resize
  },
  

  methods: {        
    async loadJewellery(sku) {
      if (this.axiosCancelToken) {
        this.axiosCancelToken.cancel("Operation canceled due to new request.");
      }
      this.axiosCancelToken = axios.CancelToken.source();

      try {
        // 1️ Load details only
        const responseDetails = await this.$axios.get(
          `/api/jewellery/${sku}/details`,
          { cancelToken: this.axiosCancelToken.token }
        );

        this.jewellery = responseDetails.data[0];
        
        this.$nextTick(() => {
          this.checkDescriptionLength();
        });
        this.$emit("route-data-ready"); // tells App.vue to hide loader
        // 2️ Load gallery asynchronously, after .section2 is rendered
        this.loadGallery(sku);
      } catch (err) {
        if (!axios.isCancel(err)) console.error("Failed to load jewellery:", err);
      }
    },
    
    async loadGallery(sku) {
      try {
        const responseImages = await this.$axios.get(
          `/api/jewellery/${sku}/images`,
          { cancelToken: this.axiosCancelToken.token }
        );
        this.images = responseImages.data[0];

        this.isGalleryLoading = true;

        this.$nextTick(() => {
          this.waitForTwoImages();
        });
      } catch (err) {
        if (!axios.isCancel(err)) console.error("Failed to load gallery:", err);
      }
    },

    waitForTwoImages() {
      if (!this.images.length) {
        this.isGalleryLoading = false;
        return;
      }

      const toLoad = this.images.slice(0, 2); // preload first 2
      let loadedCount = 0;

      toLoad.forEach((img) => {
        const loader = new Image();
        loader.src = `/jewelries/gallery/NJ-${this.jewellery.SKU}/gallery-small-image/${img.name}`;
        loader.onload = loader.onerror = () => {
          loadedCount++;
          if (loadedCount >= toLoad.length) {
            this.isGalleryLoading = false;
            // Initialize gallery when 2 images are ready
            this.$nextTick(() => {
              this.initGallery();
            });
          }
        };
      });
      // fallback: hide spinner & init gallery anyway after 5s
      setTimeout(() => {
        if (this.isGalleryLoading) {
          this.isGalleryLoading = false;
          this.initGallery();
        }
      }, 5000);
    },

    initGallery() {
        MagicZoom.refresh();
        MagicScroll.refresh();
      },

    getLondonBoutique(address) {
      this.$axios.get(address || "/api/londonboutique")
        .then(response => {
          this.londonboutique = response.data.data[0];
        });
    },

    handleResize() {
      this.checkDescriptionLength(); // Check description length on resize
    },

    checkDescriptionLength() {
      if (this.jewellery.Description) {
        this.isLongDescription = this.jewellery.Description.length > 300; // adjust threshold as needed
      } else {
        this.isLongDescription = false;
      }
    },

    expandText() {
      this.expanded = true;
    },
    contractText() {
      this.expanded = false;
    },
    toggleArticles() {
      this.showArticles = !this.showArticles;
    },
  },

  computed: {
    ...mapGetters("auth", ["authUser"]),
    isExtended() {
      return this.expanded;
    },

      contactDetails() {
      let boutique = null;

      switch (this.jewellery?.JewelleryLocation) {
        case 'London':
          boutique = this.londonboutique;
          break;

        case 'Geneva':
          boutique = this.genevaboutique;
          break;

        case 'UAE':
          boutique = this.londonboutique; // tight to London for now
          break;

        default:
          boutique = null;
      }

      if (!boutique) {
        return {
          whatsappNumber: null,
          whatsappLink: null,
          phoneNumber: null
        };
      }

      const whatsappNumber = boutique?.WhatsAppNumber || null;
      const phoneNumber = boutique?.PhoneNumber || null;

      let whatsappLink = null;

      if (whatsappNumber) {
        const message = `Hello!\nI am enquiring about ${this.jewellery.Name} - ${this.jewellery.SKU}`;
        whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(message)}`;
      }

      return {
        whatsappNumber,
        whatsappLink,
        phoneNumber
      };
    },

  },
 
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    if (this.axiosCancelToken) {
      this.axiosCancelToken.cancel(
        "Component destroyed, canceling ongoing requests."
      );
    }
  },
};

</script>























<!-- 

<script>

import EnquiryForm from '../components/EnquiryForm.vue';
import JewelleryVariants from '../components/JewelleryVariants.vue';
import { mapGetters } from "vuex";

export default {
  name: 'jewellerycard',
  
  components: {
    EnquiryForm,
    JewelleryVariants
  },
  props: ['londonboutique', 'manufacturername', 'sku', 'siteSettings'],
  locale: "en",
  
  data() {
    return {
      showArticles: false,
      i18n: '',
      searchhide: false,
      mobile: '+447741858802',
      jewellery: [],
      images: [],
      proSlug: null, // Initialize proSlug as null
      currentId: null,
      responsive: true,
      expanded: false,
      isLongDescription: false,
    };
  },
  
  created() {
    // Check the route parameter on component creation
    if (this.$route.params.jewellerySKU) {
      this.proSlug = this.$route.params.jewellerySKU; // Set proSlug from route
      this.getJewellery(this.proSlug); // Fetch jewellery data
    }
  },
  
  watch: {
    '$route.params.jewellerySKU' (newSlug) {
      this.proSlug = newSlug; // Update proSlug when the route changes
      this.getJewellery(newSlug); // Fetch new jewellery data
    },
  },
  
  mounted() {
    this.checkDescriptionLength(); // Check if text is long on component mount
    window.addEventListener('resize', this.handleResize); // Listen for window resize
  },
  
  computed: {
    ...mapGetters("auth", ["authUser"]),
    isExtended() {
      return this.expanded;
    },
  },
  
  methods: {        
    toggleArticles() {
      this.showArticles = !this.showArticles;
    },
    
    getJewellery(sku) { // Accept sku as a parameter
      this.$axios.get('/api/jewellery/' + sku).then(response => {
        this.jewellery = response.data[0];
        this.images = response.data[1];
        
        // Load scripts for magic zoom and scroll
        let magicZoomPlus = document.createElement('script');
        magicZoomPlus.setAttribute('src', '/js/magiczoomplus.js');
        document.head.appendChild(magicZoomPlus);
        
        let magicScroll = document.createElement('script');
        magicScroll.setAttribute('src', '/js/magicscroll.js');
        document.head.appendChild(magicScroll);
        
        this.$nextTick(() => {
        //   this.isLongDescriptionCheck(); // Check for long description
          this.$emit("route-data-ready");
        });
        // this.$emit("route-data-ready");
      });
    },
    
    handleResize() {
      this.isLongDescriptionCheck(); // Check for long description on resize
    },
    
    isLongDescriptionCheck() {
      const textElement = this.$refs.textElement;
      if (textElement) {
        const hasOverflow = textElement.scrollHeight > textElement.offsetHeight;
        this.isLongDescription = hasOverflow; // Update long description state
      }
    },
    
    expandText() {
      this.expanded = true; // Expand text
    },
    
    contractText() {
      this.expanded = false; // Contract text
    },
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize); // Clean up resize listener
  }, 
};

</script> -->